
import { Base } from '../base-component';
import './address.component.scss';

export class Address extends Base {

	map: google.maps.Map;

	constructor(element: Element) {

		super(element);

		this.event.register('mapInitialised', null, this.setMapOptions.bind(this));

	}

	init() {}

	bindEvents() {}

	setMarkers(markers) {

		for (const marker of markers) {

			const markerInstance = new google.maps.Marker({
				position: marker.coordinates,
				icon: marker.icon,
				title: marker.title,
				map: this.map
			});

			const infoWindow = new google.maps.InfoWindow({
				content: marker.info
			});

			markerInstance.addListener('click', () => {
				infoWindow.open(this.map, marker);
			});

		}

	}

	setMapOptions(event, mapData) {

		this.map = mapData.map;

		this.setMarkers(mapData.options.markers);

		/* const infowindow = new google.maps.InfoWindow({
			content: "<strong>test</strong>"
		});

		google.maps.event.addListener(marker, 'click', function() {
			infowindow.open(map,marker);
		});

		google.maps.event.addDomListener(window, 'resize', function() {
			map.setCenter(mapLatLng);
		}); */

	}

}




// WEBPACK FOOTER //
// ./components/address/address.component.ts